import { render } from "./FridgeDetailsRadioButtonItem.vue?vue&type=template&id=17e5f6aa&scoped=true&ts=true"
import script from "./FridgeDetailsRadioButtonItem.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsRadioButtonItem.vue?vue&type=script&lang=ts"

import "./FridgeDetailsRadioButtonItem.vue?vue&type=style&index=0&id=17e5f6aa&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e5f6aa"]])

export default __exports__